import { useEffect } from 'react';
import { Logger } from '../../utils';

export default function useHandleRoomDisconnectionErrors(room, onError) {
  useEffect(() => {
    const onDisconnected = (room, error) => {
        if (error) {
            Logger(`UI.Twilio.Room.Disconnected`, new Date(), { "error": error });        
            onError(error);
        }
    };

    room.on('disconnected', onDisconnected);
    return () => {
      room.off('disconnected', onDisconnected);
    };
  }, [room, onError]);
}
